const authConfig = {
    'region': 'us-east-1',
    'userPoolId': 'us-east-1_jpJAufRX6',
    'userPoolWebClientId': '50agvho0sijp9jn0d68udvafrn',
    'recurlyData': {
        key: 'ewr1-U2HjyhfLzv4xkZ4RpAUIVZ',
        url: 'https://js.recurly.com/v4/recurly.js'}
    };
export default authConfig;